// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"cdf6c3d0","238":"c0254a80","364":"a8809383","453":"b909ad0f","503":"41469bb6","591":"a12cde0f","637":"35adf01e","705":"1f3b140f","805":"5208bc57","885":"01702cb4","887":"93ff4e87"}[chunkId] + ".chunk.js";
};